import { FC } from 'react';
import { Switch } from 'react-router-dom';
import { PrivateRoute } from '../router/components';
import RouteConstants from '../router/RouteConstants';
import { UnifiedProfileDetails } from './components';
import { UnifiedProfiles } from './UnifiedProfiles';

export const UnifiedProfilesRouter: FC = () => (
  <>
    <Switch>
      <PrivateRoute path={`${RouteConstants.unifiedProfiles}/:id`} component={UnifiedProfileDetails} />
      <PrivateRoute path={RouteConstants.unifiedProfiles} component={UnifiedProfiles} />
    </Switch>
  </>
);
